import axios from "axios";
import { useAuthStore } from "../stores/useAuthStore";

const APIAUTH_URL = `${process.env.REACT_APP_API_AUTH}/admin`;
console.log("APIAUTH_URL:", APIAUTH_URL);

// Crear una instancia de axios
const apiClient = axios.create({
    baseURL: APIAUTH_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

// Interceptor para agregar el token a todas las peticiones
apiClient.interceptors.request.use(
    (config) => {
        const { token } = useAuthStore.getState();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor para manejar respuestas y errores de autenticación
apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const { refreshAccessToken, clearTokens } = useAuthStore.getState();
        const originalRequest = error.config;

        // Si el error es 401 (no autorizado) y no hemos intentado refrescar el token
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                // Intentar refrescar el token
                const refreshSuccess = await refreshAccessToken();

                if (refreshSuccess) {
                    // Reintenta la petición original con el nuevo token
                    const { token } = useAuthStore.getState();
                    originalRequest.headers.Authorization = `Bearer ${token}`;
                    return apiClient(originalRequest);
                } else {
                    // Si no se puede refrescar, limpiar tokens y redirigir al login
                    clearTokens();
                    window.location.href = "/acceso";
                }
            } catch (refreshError) {
                // Error al refrescar, limpiar tokens y redirigir
                clearTokens();
                window.location.href = "/acceso";
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default apiClient;
